import axioPath from "api/axioPath";
import { INVOICE_DATA, INVOICE_DOWNLOAD } from "redux/actions/action_types";

export const invoiceTableRecords = (data, token) => (dispatch) => {
  return axioPath
    .post("/order/invoice_list", data, {
      headers: {
        Authorization: `${token}`,
        UserType: "external",
      },
    })
    .then((response) => {
      dispatch({ type: INVOICE_DATA, payload: response.data, apiType: "form" });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};

export const invoiceDownload = (token, invoiceId, locationId) => (dispatch) => {
  return axioPath
    //  .get("/order/invoice/download?invoiceId="+invoiceId+"&locationId="+locationId,
    .get("/s3/get_file/"+invoiceId+".pdf",
     {
      headers: {
        Authorization: `${token}`,
        UserType: "external",
        // invoiceId: invoiceId,
        // locationId,
      },
      responseType: "blob",
    })
    .then((response) => {
      dispatch({ type: INVOICE_DOWNLOAD, payload: response.data });
      return response.data;
      // const url = window.URL.createObjectURL(new Blob([response.data]));
      // const link = document.createElement("a");
      // link.href = url;
      // link.setAttribute("download", "file.pdf");
      // document.body.appendChild(link);
      // link.click();
      // dispatch({
      //   type: INVOICE_DOWNLOAD,
      //   payload: response.data,
      //   apiType: "form",
      // });
      // return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (typeof ex === "string") {
        return { ex: { message: ex } };
      }
      return { error: true, data: ex.response?.data };
    });
};
